export default __webpack_public_path__ + "static/media/loaderYellow.8517b35d.gif";